import { render, staticRenderFns } from "./AMXRadioButtonGroup.vue?vue&type=template&id=193d6f93&scoped=true&"
import script from "./AMXRadioButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./AMXRadioButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AMXRadioButtonGroup.vue?vue&type=style&index=0&id=193d6f93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d6f93",
  null
  
)

export default component.exports